<template>
  <title-card title="Upload Files For This Loan">
    <upload-multiple-files
      v-if="checkPermissionForStandardDocument"
      :url-upload="loansDocsUrl"
      @success="onSuccessUpload"
      :show-input="true"
      :auto-send="false"
      :params="uploadParams"
    />
  </title-card>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import UploadMultipleFiles from '@/components/utils/upload/UploadMultipleFiles';
import { LOANS_WRITE } from '@/libs/permissions_list';

export default {
  name: 'UploadFiles',
  components: {
    DocumentsLegend,
    TitleCard,
    UploadMultipleFiles,
  },
  props: {
    loan: Object,
  },
  data() {
    return {
      modalRecord: {},
      uploadParams: { type: 'Salesforce' },
      showUploadModal: false,
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
      timeBeforeReload: 6000,
      maxCalls: 6,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loansDocsUrl() {
      return `/users/${this.user.id}/loans/${this.$route.params.loan_id}/docs`;
    },
    checkPermissionForStandardDocument() {
      return this.$permissions.checkPermissions([LOANS_WRITE]);
    },
  },
  methods: {
    onSuccessUpload() {
      this.$notify({
        group: 'alert',
        text: 'Uploaded successfully',
      });
      this.$emit('upload-success');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/documents/UploadFiles.vue